import React, { ReactElement } from 'react';
import { Navigate, Outlet } from 'react-router-dom';

import { checkUserPermission } from '../../../../helper';
import { useAppSelector } from '../../../../hooks';
import { getAuthState } from '../../../../store/AuthSlice';
import { IRolePermissions } from '../../../../store/V2/RolesSlice';
import { getTenantsState } from '../../../../store/V2/TenantsSlice';

const CheckPermission: React.FC<{
  permission: IRolePermissions;
  redirectPath?: string;
  children: ReactElement;
  invert?: boolean;
}> = ({
  permission,
  redirectPath = process.env.PUBLIC_URL,
  children,
  invert = false,
}): ReactElement => {
  // Store
  const authState = useAppSelector(getAuthState);
  const tenantState = useAppSelector(getTenantsState);

  const { appTenant } = tenantState;
  const { user: authUser } = authState;

  const checkPermission =
    authState.user &&
    checkUserPermission({
      authUser,
      tenant: appTenant,
      permissions: permission,
    });

  const hasPermission = invert ? !checkPermission : checkPermission;

  if (hasPermission) {
    return children || <Outlet />;
  }

  return <Navigate to={redirectPath} replace />;
};

export default CheckPermission;
